import { render } from "./PageGuideSlide.vue?vue&type=template&id=84191ca4&scoped=true&ts=true"
import script from "./PageGuideSlide.vue?vue&type=script&lang=ts"
export * from "./PageGuideSlide.vue?vue&type=script&lang=ts"

import "./PageGuideSlide.vue?vue&type=style&index=0&id=84191ca4&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84191ca4"]])

export default __exports__